import api from './api';
import type { Supplier, PaginatedResponse } from '../types/venue';
import type { SupplierItemLink } from '../types/supplierItemLink';

const BASE = '/admin/supplier';

const supplierService = {
  /** Get all suppliers. TODO Phase 3. */
  getAllSuppliers: async (
    page = 1,
    pageSize = 20,
    sort = 'name',
    order: 'asc' | 'desc' = 'asc',
    searchQuery?: string,
    type?: string
  ): Promise<PaginatedResponse<Supplier>> => {
    const params: Record<string, unknown> = { page, pageSize, sort, order };
    if (searchQuery?.trim()) params.q = searchQuery.trim();
    if (type) params.type = type;
    const response = await api.get(BASE, { params });
    return response.data;
  },

  /** Get a single supplier. TODO Phase 3. */
  getSupplier: async (supplierId: string): Promise<Supplier> => {
    const response = await api.get(`${BASE}/${supplierId}`);
    return response.data;
  },

  /** Create a supplier. TODO Phase 3. */
  createSupplier: async (
    data: Omit<Supplier, '_id' | 'createdAt' | 'updatedAt'>
  ): Promise<Supplier> => {
    const response = await api.post(BASE, data);
    return response.data;
  },

  /** Update a supplier. TODO Phase 3. */
  updateSupplier: async (
    supplierId: string,
    data: Partial<Omit<Supplier, '_id' | 'createdAt' | 'updatedAt'>>
  ): Promise<Supplier> => {
    const response = await api.put(`${BASE}/${supplierId}`, data);
    return response.data;
  },

  /** Delete a supplier. TODO Phase 3. */
  deleteSupplier: async (supplierId: string): Promise<void> => {
    await api.delete(`${BASE}/${supplierId}`);
  },

  /** Get all inventory items linked to a supplier (auto-populated from receiving). */
  getItemLinks: async (supplierId: string): Promise<SupplierItemLink[]> => {
    const response = await api.get(`${BASE}/${supplierId}/item-links`);
    return response.data;
  },
};

export default supplierService;
